import { useApp } from "../context";
import { Heading, Table } from "../components/Bits";
import { money, partnerExposure } from "../lib/engine";

const ACTOR_LABEL = { maker: "Operations maker", checker: "Finance checker" };

const LimitHistory = () => {
  const { state } = useApp();
  const history = state.limitHistory || [];
  const name = id => state.partners.find(p => p.id === id)?.name || id;
  return (
    <div className="card space">
      <h2>Limit change history</h2>
      <Table testId="limit-history-table" headers={["Time (IST)", "Partner", "Changed by", "Previous limit", "New limit", "Change"]}>
        {history.map((h, i) => (
          <tr key={h.time + i} data-testid={`limit-history-row-${i}`}>
            <td>{new Date(h.time).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
            <td><strong>{name(h.partnerId)}</strong><small>{h.partnerId}</small></td>
            <td>{ACTOR_LABEL[h.actor] || h.actor}<small>{h.by || "Before sign-in was added"}</small></td>
            <td className="number">{money(h.from)}</td>
            <td className="number">{money(h.to)}</td>
            <td className="number">
              <span className={`pill ${h.to < h.from ? "warn" : ""}`}>
                {h.to > h.from ? "+" : "−"}{money(Math.abs(h.to - h.from))}
              </span>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
};

export default function Partners() {
  const { state, actor, openModal } = useApp();
  return (
    <>
      <Heading title="DSA partners" description="Control advance exposure across the partner network." />
      <div className="notice warning">
        Illustrative policy: advance 80% of DSA entitlement after verification.
        These percentages and limits require business approval in production.
        Only the Finance checker can edit limits (simulation); every change is logged in the audit history.
      </div>
      <div className="card">
        <Table testId="partners-table"
          headers={["Partner", "City", "Cases", "Unsettled + reserved", "Limit", "Headroom", "Action"]}>
          {state.partners.map(p => {
            const exp = partnerExposure(state, p);
            return (
              <tr key={p.id} data-testid={`partner-row-${p.id}`}>
                <td><strong>{p.name}</strong><small>{p.id}</small></td>
                <td>{p.city}</td>
                <td>{state.cases.filter(c => c.partner === p.id).length}</td>
                <td className="number" data-testid={`partner-exposure-${p.id}`}>{money(exp)}</td>
                <td className="number">{money(p.limit)}</td>
                <td className="number" data-testid={`partner-headroom-${p.id}`}>{money(Math.max(0, p.limit - exp))}</td>
                <td>
                  <button data-testid={`edit-limit-btn-${p.id}`} disabled={actor !== "checker"}
                    title={actor !== "checker" ? "Finance checker account required" : undefined}
                    onClick={() => openModal({ type: "limit", id: p.id })}>Edit limit</button>
                </td>
              </tr>
            );
          })}
        </Table>
      </div>
      <LimitHistory />
    </>
  );
}
